import { useEffect, useState } from 'react';

import { FacebookIcon, LinkedinIcon, XIcon } from 'assets/icons';

const SharingLinks = ({ hashtag, className = '' }) => {
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    // Because we're prerendering this component, we need to get the current url when the window object is available
    setCurrentUrl(window.location.href);
  }, []);

  return (
    <div className={`social-sharing fl ai-c ${className}`}>
      <p className="fs-16 mb-0 mr-16">Share</p>
      <div className="social-sharing__links fl ai-c g-8">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
          target="_blank"
          rel="noreferrer"
          className="i-fl">
          <FacebookIcon width={32} height={32} />
          <span className="hide-text">Facebook</span>
        </a>

        <a
          href={`https://twitter.com/intent/tweet?url=${currentUrl}`}
          target="_blank"
          rel="noreferrer"
          className="i-fl">
          <XIcon width={32} height={32} />
          <span className="hide-text">X</span>
        </a>

        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`}
          target="_blank"
          rel="noreferrer"
          className="i-fl">
          <LinkedinIcon width={32} height={32} />
          <span className="hide-text">Linkedin</span>
        </a>
      </div>

      {hashtag && <span className="tc-cef-red ml-24">{hashtag}</span>}
    </div>
  );
};

export default SharingLinks;
